<template>
  <div>
    <b-breadcrumb class="breadcrumb">
      <b-breadcrumb-item href="/">
        <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
        首页
      </b-breadcrumb-item>
      <b-breadcrumb-item active>求职</b-breadcrumb-item>
    </b-breadcrumb>

    <b-card>
      <template v-slot:header>
        <div class="d-flex flex-row align-items-center">
          <b-form-select v-model="selectedBizType" :options="optionsBizType" size="sm" @change="searchData"></b-form-select>
          <b-form-select v-model="selectedWorkMode" :options="optionsWorkMode" size="sm" class="ml-1" @change="searchData"></b-form-select>
          <b-form-select v-model="selectedEducation" :options="optionsEducation" size="sm" class="ml-1" @change="searchData"></b-form-select>
          <b-form-select v-model="selectedWorkEnvi" :options="optionsWorkEnvi" size="sm" class="ml-1" @change="searchData"></b-form-select>
        </div>
        <div class="d-flex flex-row align-items-center mt-2">
          <b-form-input v-model="compName" type="search" size="sm" placeholder="请输入企业名称"></b-form-input>
          <b-form-input v-model="jobName" type="search" size="sm" placeholder="请输入岗位名称" class="ml-1"></b-form-input>
          <b-button variant="success" size="sm" block class="button-size ml-1" @click="searchData">检索岗位</b-button>
          <b-button variant="success" size="sm" block class="mt-0 ml-1 button-size" @click="clearSearch">清空条件</b-button>
        </div>
      </template>

      <b-card-text class="mb-1">
        <b-row>
          <b-col cols="1" class="pl-1 pr-1"> <small>月薪范围：</small></b-col>
          <b-col>
            <el-radio-group v-model="selectedsalaryRange" size="small" @change="searchData">
              <el-radio-button v-for="salaryRange in salaryRangeList" :label="salaryRange.value" :key="salaryRange.value">￥{{ salaryRange.text }}</el-radio-button>
            </el-radio-group>
          </b-col>
        </b-row>
      </b-card-text>

      <b-card-text class="mb-1">
        <b-row>
          <b-col cols="1" class="pl-1 pr-1"> <small>工作年限：</small></b-col>
          <b-col>
            <el-radio-group v-model="selectedWorkYear" size="small" @change="searchData">
              <el-radio-button v-for="wy in workYearList" :label="wy.value" :key="wy.value">{{ wy.text }}</el-radio-button>
            </el-radio-group>
          </b-col>
        </b-row>
      </b-card-text>

      <b-card-text class="mb-1">
        <b-row>
          <b-col cols="1" class="pl-1 pr-1"> <small>企业规模：</small></b-col>
          <b-col>
            <el-radio-group v-model="selectedBizSize" size="small" @change="searchData">
              <el-radio-button v-for="bs in bizSizeList" :label="bs.value" :key="bs.value">{{ bs.text }}</el-radio-button>
            </el-radio-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <b-card no-body class="mt-2 pt-2">
      <el-table :data="jobList" stripe style="width: 100%">
        <el-table-column label="岗位名称" width="200">
          <template slot-scope="scope"
            ><b-link :to="'/show-job/' + scope.row.jobRecruitmentId" target="_blank">{{ scope.row.jobName }}</b-link></template
          >
        </el-table-column>
        <el-table-column label="招聘企业" width="280">
          <template slot-scope="scope"
            ><b-link :to="'/show-comp/' + scope.row.compId" target="_blank" class="news-list">{{ scope.row.compName }}</b-link></template
          >
        </el-table-column>
        <el-table-column prop="workingPlace" label="工作地点" width="320"> </el-table-column>
        <el-table-column prop="salaryRangeName" label="薪资" width="120"> </el-table-column>
        <el-table-column prop="enterpriseTypeName" label="企业性质" width="120"> </el-table-column>
        <el-table-column prop="enterpriseSizeName" label="企业规模"> </el-table-column>
      </el-table>

      <div class="d-flex flex-row justify-content-center mt-2">
        <pagination v-show="total > 0" :total="total" :page.sync="pageNo" :limit.sync="pageSize" @pagination="searchData" />
      </div>
    </b-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'

export default {
  name: 'SearchJob',
  components: {Pagination},
  data() {
    return {
      selectedBizType: null,
      optionsBizType: [{value: null, text: '请选择企业类型'}],
      selectedWorkMode: null,
      optionsWorkMode: [{value: null, text: '请选择工作模式'}],
      selectedEducation: null,
      optionsEducation: [{value: null, text: '请选择学历要求'}],
      selectedWorkEnvi: null,
      optionsWorkEnvi: [{value: null, text: '请选择工作环境要求'}],
      selectedJobName: null,
      compName: null,
      jobName: null,
      selectedsalaryRange: null,
      salaryRangeList: [{value: null, text: '不限'}],
      selectedWorkYear: null,
      workYearList: [{value: null, text: '不限'}],
      selectedBizSize: null,
      bizSizeList: [{value: null, text: '不限'}],
      // 分页
      total: 0,
      pageNo: 1,
      pageSize: 20,
      // 岗位列表
      jobList: []
    }
  },
  mounted() {
    this.fetchBizTypeList()
    this.fetchWorkModeList()
    this.fetchEducationList()
    this.fetchWorkEnvirList()
    this.getSalaryRangeList()
    this.getWorkExperienceList()
    this.getBizSizeList()
    this.searchData()
  },
  methods: {
    /**
     * 获取有效的行业类型字典列表
     */
    fetchBizTypeList() {
      const that = this
      const postData = {}
      that
        .$http({
          method: 'post',
          url: '/portal/biz-type-list',
          data: postData
        })
        .then((d) => {
          const dSize = d.length
          that.optionsBizType = [{value: null, text: '请选择企业类型'}]
          for (let i = 0; i < dSize; i++) {
            const id = d[i].bizTypeId
            const name = d[i].bizTypeName
            const mp = {
              value: id,
              text: name
            }
            that.optionsBizType.push(mp)
          }
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取有效的行业类型字典列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    /**
     * 获取有效的工作模式字典列表
     */
    fetchWorkModeList() {
      const that = this
      const postData = {}
      that
        .$http({
          method: 'post',
          url: '/portal/work-mode-list',
          data: postData
        })
        .then((d) => {
          const dSize = d.length
          that.optionsWorkMode = [{value: null, text: '请选择工作模式'}]
          for (let i = 0; i < dSize; i++) {
            const id = d[i].workModeId
            const name = d[i].workModeName
            const mp = {
              value: id,
              text: name
            }
            that.optionsWorkMode.push(mp)
          }
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取有效的工作模式字典列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    /**
     * 获取有效的学历字典列表
     */
    fetchEducationList() {
      const that = this
      const postData = {}
      that
        .$http({
          method: 'post',
          url: '/portal/education-list',
          data: postData
        })
        .then((d) => {
          const dSize = d.length
          that.optionsEducation = [{value: null, text: '请选择学历要求'}]
          for (let i = 0; i < dSize; i++) {
            const id = d[i].educationId
            const name = d[i].educationName
            const mp = {
              value: id,
              text: name
            }
            that.optionsEducation.push(mp)
          }
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取有效的学历字典列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    /**
     * 获取有效的工作环境字典列表
     */
    fetchWorkEnvirList() {
      const that = this
      const postData = {}
      that
        .$http({
          method: 'post',
          url: '/portal/work-envir-list',
          data: postData
        })
        .then((d) => {
          const dSize = d.length
          that.optionsWorkEnvi = [{value: null, text: '请选择工作环境要求'}]
          for (let i = 0; i < dSize; i++) {
            const id = d[i].workEnvirId
            const name = d[i].workEnvirName
            const mp = {
              value: id,
              text: name
            }
            that.optionsWorkEnvi.push(mp)
          }
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取有效的工作环境字典列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    /**
     * 获取有效的薪资范围字典列表
     */
    getSalaryRangeList() {
      const that = this
      const postData = {}
      that
        .$http({
          method: 'post',
          url: '/portal/salary-range-list',
          data: postData
        })
        .then((d) => {
          const dSize = d.length
          that.salaryRangeList = [{value: null, text: '不限'}]
          for (let i = 0; i < dSize; i++) {
            const id = d[i].salaryRangeId
            const name = d[i].salaryRangeName
            const mp = {
              value: id,
              text: name
            }
            that.salaryRangeList.push(mp)
          }
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取有效的薪资范围字典列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    /**
     * 获取有效的工作年限字典列表
     */
    getWorkExperienceList() {
      const that = this
      const postData = {}
      that
        .$http({
          method: 'post',
          url: '/portal/work-experience-list',
          data: postData
        })
        .then((d) => {
          const dSize = d.length
          that.workYearList = [{value: null, text: '不限'}]
          for (let i = 0; i < dSize; i++) {
            const id = d[i].workExperienceId
            const name = d[i].workExperienceName
            const mp = {
              value: id,
              text: name
            }
            that.workYearList.push(mp)
          }
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取有效的工作年限字典列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    /**
     * 获取有效的企业规模字典列表
     */
    getBizSizeList() {
      const that = this
      const postData = {}
      that
        .$http({
          method: 'post',
          url: '/portal/biz-size-list',
          data: postData
        })
        .then((d) => {
          const dSize = d.length
          that.bizSizeList = [{value: null, text: '不限'}]
          for (let i = 0; i < dSize; i++) {
            const id = d[i].enterpriseSizeId
            const name = d[i].enterpriseSizeName
            const mp = {
              value: id,
              text: name
            }
            that.bizSizeList.push(mp)
          }
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取有效的企业规模字典列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    // 清空筛选条件
    clearSearch() {
      this.selectedBizType = null
      this.selectedWorkMode = null
      this.selectedEducation = null
      this.selectedWorkEnvi = null
      this.selectedJobName = null
      this.compName = null
      this.jobName = null
      this.selectedsalaryRange = null
      this.selectedWorkYear = null
      this.selectedBizSize = null

      this.searchData()
    },
    // 检索数据
    searchData() {
      const that = this
      const postData = {
        pageNo: that.pageNo,
        pageSize: that.pageSize,
        bizTypeId: that.selectedBizType,
        workModeId: that.selectedWorkMode,
        educationId: that.selectedEducation,
        workEnviId: that.selectedWorkEnvi,
        compName: that.compName,
        jobName: that.jobName,
        salaryRangeId: that.selectedsalaryRange,
        workYearId: that.selectedWorkYear,
        bizSizeId: that.selectedBizSize
      }
      that
        .$http({
          method: 'post',
          url: '/portal/job-page',
          data: postData
        })
        .then((d) => {
          that.total = d.total
          // that.pageSize = d.size
          // that.pageNo = d.pages === 0 ? 1 : d.pages
          const records = d.records
          this.jobList = records
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取有效的招聘岗位列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.button-size {
  width: 160px;
}
// 设置输入框、下拉选择框、按钮的字体大小
.form-control-sm {
  font-size: 14px;
}
.custom-select-sm {
  font-size: 14px;
}
.btn-sm,
.btn-group-sm > .btn {
  font-size: 14px;
}
</style>
